import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

type Props = {
  images: string[];
  alt?: string | null;
  title?: string | null;
};

export function Carousel({ images, alt, title }: Props) {
  return (
    <Swiper
      modules={[Autoplay]}
      slidesPerView={1}
      loop={true}
      speed={600}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
    >
      {images?.map((img, imgIndex) => (
        <SwiperSlide key={imgIndex}>
          <img
            src={img}
            alt={alt || title || 'Image'}
            height={300}
            width={300}
            loading="lazy"
            className="img-fluid rounded fixed-size-image"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
